import { Container, Content } from "./styles";

import facebook from "../../assets/end-facebook.svg";
import instagram from "../../assets/end-instagram.svg";
import linkedin from "../../assets/end-linkedin.svg";
import youtube from "../../assets/end-youtube.svg";
import tiktok from "../../assets/end-tiktok.png";

export default function NotMeetRequirements() {
  return (
    <Container>
      <Content>
        <h1>
          Para seguir com a inscrição na Kenzie Academy, é necessário cumprir
          todos os pré-requisitos do formulário de inscrição
        </h1>
        <p>
          Como você indicou que não cumpre atualmente com algum deles,
          infelizmente ainda não será possível seguir em frente no processo
          seletivo.
        </p>
        <p>
          Só que ainda tem muito mais Kenzie para você! Não deixe de conferir as
          nossas redes sociais para aproveitar todo o nosso conteúdo:
        </p>
        <div>
          <a
            href="https://www.facebook.com/kenzieacademybr/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebook} alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/kenzieacademybr/?hl=pt-br"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagram} alt="Instagram" />
          </a>
          <a
            href="https://www.linkedin.com/school/kenzie-academy-brasil/mycompany/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedin} alt="Linkedin" />
          </a>
          <a
            href="https://www.youtube.com/channel/UC6rcCbDzhVoIm1V7WnwPDIQ"
            target="_blank"
            rel="noreferrer"
          >
            <img src={youtube} alt="Youtube" />
          </a>
          <a
            href="https://www.tiktok.com/@kenzieacademy_br?lang=pt-BR"
            target="_blank"
            rel="noreferrer"
          >
            <img src={tiktok} alt="Tiktok" />
          </a>
        </div>
      </Content>
    </Container>
  );
}
